import React, { Component } from 'react';

import { Typography } from 'material-ui';
import { Title } from '../helper/consts';
const style = {
	section: {
		background:
			'radial-gradient(ellipse 100% 100% at 90% 10%, #9271f6, #474ab6)',
		width: '100vw',
		right: 0,
		minHeight: '100px',
		// height:'30vw',
		// maxHeight:'390px',
		// marginTop:'-75px',
		alignItems: 'center',
		paddingTop: '175px',
		paddingBottom: '25px',
		display: 'flex',
		justifyContent: 'center'
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		flexWrap: 'wrap',
		width: '80%',
		minWidth: '320px'
	},
	column: {
		width: '40%',
		margin: '0 20px',
		display: 'flex',
		flexWrap: 'wrap'
	},
	columnRight: {
		display: 'flex',
		justifyContent: 'flex-end'
	}
};

export default class Footer extends Component {
	render() {
		return (
			<footer style={style.section}>
				<div style={style.contentContainer}>
					<div style={style.column} className="infoContainer">
						<div className="logo" />
						<Typography
							style={{ color: 'white', display: 'flex' }}
							type={'title'}
						>
							© <span id="titleBrandMark">{Title}</span>
						</Typography>
					</div>
					<div
						style={{ ...style.column, ...style.columnRight }}
						className="linksContainer"
					/>
				</div>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Footer.js